import baseQueryWithReauth from '@app/helper/baseQueryWithReAuth';
import type {TAppLogCreate} from '@app/types';
import {createApi} from '@reduxjs/toolkit/query/react';
import type {TAppLog} from '@app/types';
import {CONSTANTS} from '@app/constants';

export const appLogService = createApi({
  reducerPath: 'appLogService',
  tagTypes: ['AppLog'],
  baseQuery: baseQueryWithReauth,
  endpoints(builder) {
    return {
      sendLog: builder.mutation<TAppLog, TAppLogCreate>({
        query: (body) => ({
          url: '/app_logs',
          method: 'POST',
          headers: {
            [CONSTANTS.APP_SOURCE_HEADER_KEY]:
              CONSTANTS.APP_SOURCE_HEADER_VALUE,
          },
          body: body,
        }),
      }),
    };
  },
});

export const {useSendLogMutation} = appLogService;
